module.exports = __webpack_public_path__ + "static/media/k3.1d9b509f.jpg";